import css from './sass/style.scss';

require('./js/fonts.js');
require('./js/polyfills.js');
require('./js/init.js');
require('./js/buybtn.js');
require('./js/cookies.js');
require('./js/appform.js');
require('./js/carousels.js');
require('./js/filters.js');
//require('./js/glightbox.js');
require('./js/helpers.js');
require('./js/ismobile.js');
require('./js/inview.js');
require('./js/map.js');
require('./js/gototarget.js');

require('./js/newsletter.js');
require('./js/nav.js');
//require('./js/presslatest.js');
require('./js/splitting.js');
require('./js/upload.js');
require('./js/vimeo.js');
require('./js/yt.js');
//require('./js/fixel.js');
//require('./js/scrollpos.js');
//require('./js/scrollprogress.js');


//require('./js/mobile-detach.js');




require('./img/assets/cookie.png');
require('./img/assets/cookie@2x.png');

require('./img/assets/logo-junk.png');
require('./img/assets/logo-junk@2x.png');
require('./img/assets/logo-rebelia.png');
require('./img/assets/logo-rebelia@2x.png');

require('./img/photos/avatars/01.jpg');
require('./img/photos/avatars/01@2x.jpg');
require('./img/photos/avatars/03.jpg');
require('./img/photos/avatars/03@2x.jpg');

require('./img/photos/bg/header.jpg');
require('./img/photos/bg/junk-yard.jpg');

require('./img/photos/news/big/01.jpg');
require('./img/photos/news/big/01@2x.jpg');
require('./img/photos/news/big/02.jpg');
require('./img/photos/news/big/02@2x.jpg');
require('./img/photos/news/big/03.jpg');
require('./img/photos/news/big/03@2x.jpg');

require('./img/photos/news/small/01.jpg');
require('./img/photos/news/small/01@2x.jpg');

require('./img/photos/office.jpg');
require('./img/photos/office@2x.jpg');

require('./img/photos/placeholders/already-played--small.jpg');
require('./img/photos/placeholders/already-played--small@2x.jpg');
require('./img/photos/placeholders/already-played.jpg');
require('./img/photos/placeholders/already-played@2x.jpg');
require('./img/photos/placeholders/final-trailer.jpg');
require('./img/photos/placeholders/final-trailer@2x.jpg');

require('./img/photos/placeholders/mechanics-01.jpg');
require('./img/photos/placeholders/mechanics-01@2x.jpg');

require('./img/photos/placeholders/trailer.jpg');
require('./img/photos/placeholders/trailer@2x.jpg');

require('./img/video.mp4');
